/**
 * Traffic link dialog rules: which tracker tiles it shows, the id placeholder,
 * when Save is possible, and which saves need the stats caches refreshed.
 * Voluum and Binom behave exactly as before; Tres Commas only where enabled.
 * For Media Devoted | Created By Ciro Autiero
 */

import { assertNever, trackerEnum, type TrackerId } from '@trafficpulse/shared';

import type { PatchTrafficProvider } from '@/hooks';

/** One tile per enabled tracker, in registry order (Voluum, Binom, then Tres Commas). */
export function linkChoices(enabled: readonly TrackerId[]): PatchTrafficProvider[] {
  return enabled.map(trackerEnum);
}

export function isTresCommasLink(provider: PatchTrafficProvider): boolean {
  switch (provider) {
    case 'VOLUUM':
    case 'BINOM':
      return false;
    case 'TRES_COMMAS':
      return true;
    default:
      return assertNever(provider, 'traffic provider');
  }
}

/** Placeholder of the free-text id field (Voluum / Binom — Tres Commas uses a picker). */
export function campaignIdPlaceholder(provider: PatchTrafficProvider): string {
  switch (provider) {
    case 'VOLUUM':
      return 'Voluum campaign UUID';
    case 'BINOM':
      return 'Binom campaign id';
    case 'TRES_COMMAS':
      return 'Tres Commas campaign id';
    default:
      return assertNever(provider, 'traffic provider');
  }
}

/** Tres Commas needs a campaign (the backend refuses TRES_COMMAS without one); others as before. */
export function canSaveLink(provider: PatchTrafficProvider, campaignId: string): boolean {
  return !isTresCommasLink(provider) || campaignId.trim() !== '';
}

/** A save to or from Tres Commas: its stats caches are refreshed afterwards. */
export function touchesTresCommas(from: PatchTrafficProvider, to: PatchTrafficProvider): boolean {
  return isTresCommasLink(from) || isTresCommasLink(to);
}
